
import {Component, Prop, Vue} from "vue-property-decorator";

// #268 リニューアルページ共通のページヒーロー(キッカー+タイトル+サブ)
@Component
export default class PageHero extends Vue {
  @Prop({type: String, required: true})
  kicker!: string;

  @Prop({type: String, required: true})
  title!: string;

  @Prop({type: String, required: false, default: ""})
  sub!: string;
}
